var React = require('react');

function CheckboxFilled (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0H42V42H0V0Z","fill":"white","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M27.2222 13H14.7778C13.7911 13 13 13.8 13 14.7778V27.2222C13 28.2 13.7911 29 14.7778 29H27.2222C28.2089 29 29 28.2 29 27.2222V14.7778C29 13.8 28.2089 13 27.2222 13ZM19.2222 25.4444L14.7778 21L16.0311 19.7467L19.2222 22.9289L25.9689 16.1822L27.2222 17.4444L19.2222 25.4444Z","fill":"#4C3371","key":1})]);
}

CheckboxFilled.defaultProps = {"width":"42","height":"42","viewBox":"0 0 42 42","fill":"none"};

module.exports = CheckboxFilled;

CheckboxFilled.default = CheckboxFilled;
